import { candleParser } from './candleParser';

/**
 * * This would be if the current price filters out trigger candle for a tactic. 
 * An example would occur with the candle trigger setup, and if the current price is above the break price.
 * Depending on how a tradePlan is configured, this would result in a specific action. Sometimes, it might result
 * in the trade plan being terminated. Other times, it might mean that we just remove that short trigger, but the long 
 * trigger is still valid. This action is governed by the field: action
 * 
 * {
	"messageType": "alertNotification",
	"notificationId": 1645469980648,
	"notificationDetails": {"errorType":"TACTIC_VALIDATION","notificationType":"ERROR","tacticName":"CANDLE_TRIGGER","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "PRICE_FILTERS_TRIGGER_CANDLE",
	"statusDetails": {"price":100.1,"action":"SKIP_SHORT_TRIGGER","candle":{"high":100.2,"low":100.2,"open":100.2,"close":100.2,"candleSymbol":"XTz","duration":"1min"}},
	"date": "2022-02-21T13:59:41.566-0500",
	"timestamp": "1645469981567"
}
 * @param {*} statusDetails 
 * @returns an object with the fields:
 *  1) price: current price
 *  2) action: that b.e will take as a result of the filter (SKIP_LONG_TRIGGER, SKIP_SHORT_TRIGGER, WAIT_FOR_NEXT_CANDLE, CREATE_BOUNCE_TRIGGER, TERMINATE_TRADE_PLAN)
 *  3) candle-> Before using this field, check if it is null. it contains an object that contains the fields:
 *    a) high
 *    b) low
 *	  c) open
 *    d) candleSymbol
 *    e) duration (1min/1day...)
 */
export function priceFiltersTriggerCandleParser(statusDetails) {
  const parsedObj = {
    price: null,
    action: null,
    candle: null,
  };
  if (statusDetails) {
    parsedObj.price = statusDetails.price ?? null;
    parsedObj.action = statusDetails.action ?? null;
    parsedObj.candle = statusDetails.candle
      ? candleParser(statusDetails.candle)
      : null;
  }
  return parsedObj;
}
